<div class="AgentView">
  <div class="close-btn ms-auto mb-3" style="margin-right: -8px;" (click)="closeTimeSlotModal()">
    <span class="d-block" style="color: rgb(102, 102, 102);">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
        <path
          d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z">
        </path>
      </svg>
    </span>
  </div>
  <div class="w-100 overflow-y-auto">
    <div class="heading">
      <h1 class="mb-0"><strong>Buchbare Zeitfenster</strong></h1>
    </div>
    <div class="greenArea" [ngClass]="{redArea: sheduledStatus.scheduledCount < sheduledStatus.terminAgentsCount}">
      <div class="d-flex align-items-center gap-2">
        <div [ngStyle]="sheduledStatus.scheduledCount < sheduledStatus.terminAgentsCount ? { 'border-color': '#AF1C3D', 'background-color': '#FFE3EA', 'color': '#AF1C3D' } : { 'border-color': '#24B89B', 'background-color': '#E7FFFA', 'color': '#24B89B'}">
          <svg xmlns:xlink="http://www.w3.org/1999/xlink" fill="currentColor" width="20"
            xmlns="http://www.w3.org/2000/svg" id="screenshot-784c5983-b509-808f-8003-ecc640384bb8" version="1.1"
            viewBox="6880.647 705.571 17.131 15" height="20">
            <g id="shape-784c5983-b509-808f-8003-ecc640384bb8">
              <g class="fills" id="fills-784c5983-b509-808f-8003-ecc640384bb8">
                <path rx="0" ry="0" fill="currentColor"
                  d="M6888.356,720.571L6888.356,718.904L6895.209,718.904L6895.209,712.987C6895.209,711.362,6894.627,709.984,6893.464,708.852C6892.301,707.721,6890.884,707.155,6889.213,707.154C6887.543,707.154,6886.126,707.720,6884.963,708.852C6883.800,709.985,6883.218,711.363,6883.217,712.987L6883.217,718.071L6880.647,718.071L6880.647,713.300L6881.504,713.300L6881.568,712.196C6881.682,711.251,6881.965,710.376,6882.414,709.571C6882.864,708.765,6883.428,708.064,6884.106,707.467C6884.784,706.869,6885.562,706.404,6886.439,706.071C6887.317,705.737,6888.242,705.571,6889.213,705.571C6890.184,705.571,6891.105,705.737,6891.975,706.071C6892.846,706.404,6893.624,706.866,6894.310,707.457C6894.995,708.047,6895.559,708.744,6896.001,709.550C6896.444,710.355,6896.729,711.230,6896.858,712.175L6896.922,713.300L6897.779,713.300L6897.779,718.071L6896.922,718.071L6896.922,720.571ZM6886.643,714.737C6886.401,714.737,6886.197,714.657,6886.033,714.497C6885.870,714.337,6885.787,714.140,6885.787,713.904C6885.787,713.668,6885.869,713.470,6886.033,713.311C6886.198,713.151,6886.401,713.071,6886.643,713.071C6886.886,713.071,6887.090,713.151,6887.254,713.311C6887.419,713.471,6887.500,713.669,6887.500,713.904C6887.500,714.140,6887.418,714.338,6887.253,714.498C6887.089,714.658,6886.885,714.738,6886.643,714.737ZM6891.783,714.737C6891.540,714.737,6891.337,714.657,6891.173,714.497C6891.009,714.337,6890.927,714.140,6890.926,713.904C6890.926,713.668,6891.008,713.470,6891.173,713.311C6891.337,713.151,6891.541,713.071,6891.783,713.071C6892.025,713.071,6892.229,713.151,6892.393,713.311C6892.558,713.471,6892.640,713.669,6892.639,713.904C6892.639,714.140,6892.557,714.338,6892.393,714.498C6892.228,714.658,6892.025,714.738,6891.783,714.737ZM6884.095,713.446C6883.995,711.974,6884.452,710.710,6885.466,709.654C6886.479,708.599,6887.743,708.071,6889.256,708.071C6890.526,708.071,6891.644,708.463,6892.608,709.247C6893.571,710.032,6894.153,711.036,6894.352,712.259C6893.053,712.245,6891.858,711.904,6890.766,711.237C6889.674,710.571,6888.835,709.668,6888.249,708.529C6888.021,709.640,6887.539,710.630,6886.804,711.498C6886.069,712.367,6885.166,713.016,6884.095,713.446Z">
                </path>
              </g>
            </g>
          </svg>
        </div>
        <div>
          <p class="mb-2 time-slot slot-duration">Slotdauer - 30 Min.</p>
          <p class="mb-0 time-slot interview-slot-duration">
            Agent Interview Zeitfenster
          </p>
        </div>
      </div>
      <div class="d-flex align-items-end">
        <p class="mb-0" style="color: #24B89B" [ngStyle]="sheduledStatus.scheduledCount < sheduledStatus.terminAgentsCount ? {color: '#AF1C3D'} : {color: '#24B89B'}">{{sheduledStatus.terminAgentsCount}} von {{sheduledStatus.scheduledCount}}</p>
      </div>
    </div>

    <div class="detailArea">

      <div class="d-flex timeContent">
        <div class="timerWindow">
          <div class="richText23">
            <div>
              <img src="https://api.iconify.design/bx/calendar.svg?color=%23666" alt="" width="22" height="22" />
            </div>
          </div>
          <div class="richText22">
            <div>
              <span style="color: rgb(102, 102, 102)">Kalenderwoche</span>
            </div>
          </div>
        </div>

        <div class="addTimer">
          <mat-form-field appearance="fill" class="primary-color-field">
            <mat-label>Kalenderwoche auswählen</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Start date" [(ngModel)]="startDate" [min]="currentDate">
              <input matEndDate placeholder="End date" [(ngModel)]="endDate" (dateChange)="onDateChange($event)">
            </mat-date-range-input>
            <mat-hint>DD.MM.YYYY – DD.MM.YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>

      <!-- row two -->

      <div class="d-flex justify-content-between timeContent">
        <div class="timerWindow">
          <div class="richText232">
            <div>
              <img src="https://api.iconify.design/iconamoon/clock.svg?color=%23666" alt="" width="22" height="22" />
            </div>
          </div>
          <div class="richText222">
            <div>
              <span style="color: rgb(102, 102, 102)">Zeitfenster</span>
            </div>
          </div>
        </div>

        <div class="addTimer">
          <div class="tagesZeile" *ngFor="let day of orders; let i = index">
            <div class="Layout2345678">
              <div class="days">
                <span class="weekday-date" *ngIf="weekDates[day.english]">{{ weekDates[day.english] }} </span><span class="weekday-name">{{ day.german }}</span>
              </div>
            </div>
            <div class="multipleTimeSlot"
              [ngClass]="{ 'd-flex': timeSlots[day.english] && timeSlots[day.english].length, 'd-none': !(timeSlots[day.english] && timeSlots[day.english].length) }">
              <div *ngFor="let slot of timeSlots[day.english]; let j = index" class="d-flex align-items-start" style="margin-left: 0rem; gap: 10px;">
                <div class="w-100 d-flex align-items-center justify-content-between" style="max-width: 270px;">
                  <div class="d-flex align-items-center flex-column">
                    <div class="d-flex align-items-center">
                      <ng-container *ngIf="timeSlots[day.english]">

                        <ejs-timepicker
                          [id]="'timeInput' + i"
                          placeholder='Zeit auswählen'
                          [step]='interval'
                          [format]='formatString'
                          [(ngModel)]="slot.from"
                          (change)="getSchedleDurtion(timeSlots, day.english, j)" [min]="getFormattedFrom(timeSlots[day.english][j].from)">
                        </ejs-timepicker>
                        <!-- [readonly]="currentUserRole=='Admin'" -->


                        <div class="richText23456" style="margin: 0px 16px">
                          <div>bis</div>
                        </div>

                        <ejs-timepicker
                          [id]="'timeInputEnd' + i"
                          placeholder='Zeit auswählen'
                          [step]='interval'
                          [format]='formatString'
                          [(ngModel)]="slot.to"
                          (blur)="validateAndFixTimeInput(slot, 'to')"
                          (change)="getSchedleDurtion(timeSlots, day.english, j)" [min]="getFormattedFrom(timeSlots[day.english][j].from)">
                        </ejs-timepicker>
                        <!-- [readonly]="currentUserRole=='Admin'" -->

                      </ng-container>
                    </div>
                    <div *ngIf="validateTimeSlot(slot.from, slot.to) && slot.from && slot.to"
                    style="margin-top: 8px; width: 100%;">
                    <span class="d-block text-center error" style="font-size: 12px;">Das Zeitfenster muss mindestens 30 Minuten betragen.</span>
                    </div>
                    <div *ngIf="isMultipleOf30Minutes(slot.from, slot.to) && slot.from && slot.to && !validateTimeSlot(slot.from, slot.to)"
                      style="margin-top: 8px; width: 100%;">
                      <span class="d-block text-center error" style="font-size: 12px;">Das Zeitfenster muss Vielfaches von 30 Minuten sein.</span>
                    </div>
                    <div *ngIf="!zigZagValidation(day.english, j) && slot.from && slot.to && errorZigZag[j]"
                      style="margin-top: 8px; width: 100%;">
                      <span class="d-block text-center error" style="font-size: 12px;">Sie können nicht denselben Slot auswählen oder sich mit einem bestehenden Slot überschneiden.</span>
                    </div>
                  </div>

                </div>
              <div class="d-flex gap-2">
              <div
                class="add-slot-btn" [ngClass]="{ 'disabled': !isDayWithinRange(day.english) }"
                (click)="removeSlotForDay(day.english, j)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="26" height="26" fill="currentColor">
                  <path
                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z">
                  </path>
                </svg>
              </div>
              <div
                class="add-slot-btn" [ngClass]="{ 'disabled': !isDayWithinRange(day.english) }"
                (click)="addSlotFor(day.english)" *ngIf="j === timeSlots[day.english].length - 1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="26" height="26" fill="currentColor">
                  <path
                    d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z">
                  </path>
                </svg>
              </div>
              </div>
            </div>
            </div>
            <div *ngIf="timeSlots[day.english].length < 1" style="border: 1px dotted #606060;
                  border-radius: 5px;
                  padding: 2px 5px;
                  max-width: 270px;
                  width: 100%;
                  display: flex;
                  justify-content: center;">
              <p class="mb-0">Nicht Verfügbar</p>
            </div>
            <div
                class="add-slot-btn" [ngClass]="{ 'disabled': !isDayWithinRange(day.english)}"
                (click)="addSlotFor(day.english)" *ngIf="timeSlots[day.english].length < 1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="26" height="26" fill="currentColor">
                  <path
                    d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z">
                  </path>
                </svg>
              </div>
            <div class="d-flex align-items-center justify-content-between gap-3">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bottomRow">
    <button #thisbutton_cssbutton type="button" class="cssButton" (click)="closeTimeSlotModal()">
      <div class="focus:outline-0 bg-transparent">
        <span> Abbrechen </span>
      </div>
    </button>
    <button #thisbutton_cssbutton2 type="button" class="cssButton2"
    (click)="saveAndCloseDialog();" *ngIf="isObjectEmpty(selectedTimeSlot)" [disabled]="areAllArraysEmpty || !startDate || !endDate || timeSlotError || slotOverlapError">
    <div class="focus:outline-0 bg-transparent">
      <span> Speichern </span>
    </div>
    </button>
  <button #thisbutton_cssbutton2 type="button" class="cssButton2"
    (click)="updateAndCloseDialog();" *ngIf="!isObjectEmpty(selectedTimeSlot)" [disabled]="areAllArraysEmpty || !startDate || !endDate || timeSlotError || slotOverlapError">
    <div class="focus:outline-0 bg-transparent">
      <span> Aktualisieren </span>
    </div>
  </button>
  </div>

</div>